import { render, staticRenderFns } from "./InternetRequiredComp.vue?vue&type=template&id=4b03eea7&"
import script from "./InternetRequiredComp.vue?vue&type=script&lang=js&"
export * from "./InternetRequiredComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports